import { motion } from "framer-motion";

const nav = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

export default function ThankYou({ onBack }) {
  return (
    <div className="fixed inset-0 z-[200] bg-white flex items-center justify-center px-5" role="main">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: "radial-gradient(#E31837 1px, transparent 1px)", backgroundSize: "28px 28px" }} />

      <motion.div
        initial={{ opacity: 0, scale: 0.92, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center max-w-md"
      >
        {/* Success icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200, damping: 15 }}
          className="w-20 h-20 bg-green-50 border-2 border-green-200 rounded-full flex items-center justify-center mx-auto mb-7"
        >
          <svg className="w-10 h-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </motion.div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-[34px] text-gray-900 mb-3 tracking-tight"
          style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800 }}>
          Enquiry Received!
        </h1>
        <p className="text-gray-500 text-base leading-relaxed mb-2">
          Thank you for reaching out to <span className="text-gray-800 font-semibold">BW Elite LLC</span>.
        </p>
        <p className="text-gray-400 text-sm leading-relaxed mb-8">
          We've received your enquiry and will contact you via <strong className="text-gray-600">SMS</strong> within
          the next few minutes during business hours (Mon–Sat, 9 AM–7 PM).
        </p>

        {/* Info box */}
        <div className="bg-gray-50 border border-gray-100 rounded-2xl p-5 mb-8 text-left">
          <p className="text-gray-500 text-sm leading-relaxed">
            📱 <span className="font-medium text-gray-700">What happens next?</span>
            <br />
            Our team will send you a text message with pricing, availability and delivery details
            for the parts you requested.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => { onBack(); nav("#products"); }}
            className="bg-red-600 hover:bg-red-700 text-white font-bold px-7 py-3.5 rounded-2xl text-sm
                       transition-all duration-200 shadow-lg shadow-red-600/25 hover:-translate-y-0.5"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Back to Products
          </button>
          <button
            onClick={onBack}
            className="border border-gray-200 text-gray-500 hover:text-gray-800 hover:border-gray-300
                       font-semibold px-7 py-3.5 rounded-2xl text-sm transition-all duration-200"
          >
            Go to Home
          </button>
        </div>
      </motion.div>
    </div>
  );
}
